module.exports = __webpack_public_path__ + "img/Monaco.61591c8b.png";